export const mainReceipt = {
    title: "Recette",
    loading: "Chargement de la recette",
    cancel: {
        label: "perdre vos modifications",
        title: "Annulation",
        content: "Vous êtes sur le point d'annuler l'ensemble de vos modifications. Vous confirmez ?"
    },
    create: "La recette {number} a bien été sauvegardée."
}